// extracted by mini-css-extract-plugin
export default {"itemContainer":"BenefitSuscriptionList_itemContainer__Jg446"};